export const WallboardConst = {
  path: '/wallboard',
  routePath: 'wallboard',
  apiUrlSegment: '/api/v2/wallboards/',
  errors: {
    readOnly: 'A wallboard is read-only.',
    tokenMissing: 'Wallboard token is missing.',
    notSupported: 'Not supported for the wallboard.',
  },
  requestHeaders: { 'X-Nimbus-Wallboard': 'true' },
  transientRetry: {
    maxRetries: 10,
    delayStepMs: 10000,
    delayMaxMs: 60000,
  },
  renew: {
    minDelayMs: 10000,
    retryDelayMs: 60000,
  },
};
